import React from 'react';
import styled, { keyframes } from 'styled-components';

// Gaming: Cyberpunk neon cards with glowing borders, ticket-style dividers
const GamingTheme = ({ colorTheme }: { colorTheme: string }) => {
   return (
      <Wrapper>
         <Heading>⚡ CHOOSE YOUR POWER</Heading>
         <Card $active>
            <GlowBorder />
            <CardInner>
               <Badge>3 HRS</Badge>
               <Info>
                  <Title>UNLIMITED</Title>
                  <Desc>High-speed internet</Desc>
               </Info>
               <Price>₱50</Price>
            </CardInner>
         </Card>
         <Card>
            <CardInner>
               <Badge>1 DAY</Badge>
               <Info>
                  <Title>UNLIMITED</Title>
                  <Desc>Full day access</Desc>
               </Info>
               <Price>₱80</Price>
            </CardInner>
         </Card>
         <Card>
            <CardInner>
               <Badge>3 DAYS</Badge>
               <Info>
                  <Title>UNLIMITED</Title>
                  <Desc>Weekend pack</Desc>
               </Info>
               <Price>₱150</Price>
            </CardInner>
         </Card>
      </Wrapper>
   );
};

const glow = keyframes`
   0%, 100% { box-shadow: 0 0 4px rgba(0,230,118,0.3); }
   50% { box-shadow: 0 0 8px rgba(0,230,118,0.6); }
`;

const Wrapper = styled.div`
   display: flex; flex-direction: column; gap: 5px;
`;
const Heading = styled.p`
   font-size: 8px; font-weight: 800; color: #00e676;
   text-align: center; letter-spacing: 1px; margin-bottom: 2px;
`;
const Card = styled.div<{ $active?: boolean }>`
   position: relative; background: #141420;
   border: 1px solid ${({ $active }) => $active ? '#00e676' : 'rgba(255,255,255,0.06)'};
   border-radius: 6px; overflow: hidden;
   ${({ $active }) => $active && `animation: none;`}
`;
const GlowBorder = styled.div`
   position: absolute; inset: 0; border-radius: 6px;
   animation: ${glow} 2s ease-in-out infinite; pointer-events: none;
`;
const CardInner = styled.div`
   display: flex; align-items: center; gap: 6px; padding: 7px 8px;
`;
const Badge = styled.span`
   font-size: 7px; font-weight: 800; background: #00e676; color: #0a0a0f;
   padding: 2px 5px; border-radius: 3px; white-space: nowrap;
`;
const Info = styled.div`flex: 1;`;
const Title = styled.p`font-size: 9px; font-weight: 700; color: #e0e0e0;`;
const Desc = styled.p`font-size: 7px; color: #555;`;
const Price = styled.span`
   font-size: 14px; font-weight: 900; color: #00e676;
   font-family: 'Courier New', monospace;
`;

export default GamingTheme;
